import { InjectionToken } from '@angular/core';

import type * as _Features from '../features';

export type Features = typeof _Features;

export const APP_FEATURES = new InjectionToken<Features>('APP_FEATURES');
